import { Text, View } from "@react-pdf/renderer";
import { invoiceDocuStyles } from "../core/Helper";
import { useSelector } from "react-redux";

export function InvoiceHeader(props) {
  //   const userDetail = useSelector((state) => state.user.detail);
  console.log(props);
  const { data } = props;
  return (
    <View style={invoiceDocuStyles.header}>
      <Text>{data?.part + "\t\r\n xxxxx \tx2"}</Text>
    </View>
  );
}
